(function() {
    'use strict';

    angular
        .module('atheer.system', [

        ]);
})();
